import { Avatar, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useImposter } from 'Hooks';
import { NoImageAvatar } from 'Images';

export const User = () => {
  const { authenticatedUser, fakeUser } = useImposter();

  return (
    <Stack
      direction='row'
      sx={{
        alignItems: 'center',
        gap: '12px',
      }}
    >
      <Avatar alt='' src={NoImageAvatar} />
      <Typography variant='h3' color={'initial'} component='h2'>
        {Dictionary[DICTIONARY.Home].helloName(
          `${fakeUser.firstName || authenticatedUser.firstName || ''} ${
            fakeUser.lastName || authenticatedUser.lastName || ''
          }`
        )}
      </Typography>
    </Stack>
  );
};
